"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DodoPointIntroInfoResponseSchema = exports.DODO_POINT_INTRO_STATUS = void 0;
var zod_1 = require("zod");
exports.DODO_POINT_INTRO_STATUS = {
    NOT_LOGIN: 'NOT_LOGIN',
    TERM_NOT_AGREED: 'TERM_NOT_AGREED',
    OK: 'OK',
};
exports.DodoPointIntroInfoResponseSchema = zod_1.z.object({
    /** Intro 지면 상태 */
    status: zod_1.z.enum([
        exports.DODO_POINT_INTRO_STATUS.NOT_LOGIN,
        exports.DODO_POINT_INTRO_STATUS.TERM_NOT_AGREED,
        exports.DODO_POINT_INTRO_STATUS.OK,
    ]),
    /** 타이틀 */
    title: zod_1.z.array(zod_1.z.string()),
    /** 약관 정보 */
    term: zod_1.z
        .object({
        id: zod_1.z.string(),
        prefix: zod_1.z.string(),
        title: zod_1.z.string(),
    })
        .optional(),
    /** 하단 버튼명 정보 */
    buttonName: zod_1.z.string(),
    /** 클라이언트 로그 관련 정보 */
    logMeta: zod_1.z.object({
        title: zod_1.z.string(),
    }),
});
